import { SPRITE_SYMBOLS } from "@/assets/icons/sprite/IconSprite";
import { SpriteIcon } from "@/assets/icons/sprite/SpriteIcon";
import { IconProps } from "@/common/contracts/icon.contracts";

export const Spark = (props: IconProps) => {
  return (
    <svg
      width="44"
      height="22"
      viewBox="0 0 44 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.0629 18.7018C22.541 18.7028 23.0015 18.5283 23.3508 18.2136C23.7002 17.899 23.9121 17.4679 23.9435 17.008L24.8893 3.15973C24.9127 3.02098 24.9252 2.88073 24.9269 2.74016C24.9269 2.71685 24.9269 2.69614 24.9269 2.67283V2.62103C24.895 1.91559 24.5819 1.24923 24.0528 0.760904C23.5238 0.272582 22.8195 0 22.087 0C21.3546 0 20.6503 0.272582 20.1212 0.760904C19.5921 1.24923 19.279 1.91559 19.2472 2.62103H19.2123L20.1822 17.008C20.2136 17.4679 20.4255 17.899 20.7749 18.2136C21.1242 18.5283 21.5848 18.7028 22.0629 18.7018Z"
        fill="currentColor"
      />
      <path
        d="M31.9889 20.8501L42.8163 11.7025C42.9356 11.6254 43.0479 11.5388 43.1521 11.4435L43.1978 11.3943L43.2381 11.3606C43.7415 10.842 44.0162 10.155 44.0039 9.44479C43.9917 8.73458 43.6936 8.05676 43.1725 7.55449C42.6515 7.05223 41.9484 6.76485 41.2116 6.75306C40.4749 6.74127 39.7622 7.00599 39.2242 7.49131L39.2 7.468L29.3371 18.2913C29.0249 18.6375 28.8605 19.085 28.877 19.5435C28.8935 20.0019 29.0897 20.4374 29.426 20.7619C29.7624 21.0865 30.2138 21.276 30.6894 21.2924C31.165 21.3088 31.6294 21.1507 31.9889 20.8501Z"
        fill="currentColor"
      />
      <path
        d="M14.5785 20.766C14.9156 20.4404 15.1118 20.0036 15.1273 19.5438C15.1427 19.0841 14.9763 18.6359 14.6618 18.29L4.80701 7.44859L4.78015 7.4719C4.24211 6.98658 3.52945 6.72186 2.7927 6.73365C2.05595 6.74544 1.35281 7.03282 0.831776 7.53509C0.310745 8.03735 0.0126227 8.71517 0.00039171 9.42538C-0.0118393 10.1356 0.262775 10.8226 0.766224 11.3412L0.806523 11.3749C0.822643 11.3904 0.836075 11.4086 0.854882 11.4241C0.958714 11.5187 1.07011 11.6053 1.18804 11.6831L12.0154 20.8307C12.3719 21.1344 12.8346 21.2967 13.3102 21.2846C13.7858 21.2726 14.239 21.0873 14.5785 20.766Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const WhoppahSpark = (props: IconProps) => {
  return (
    <svg
      width="31"
      height="39"
      viewBox="0 0 31 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.4545 29.9404L17.7199 19.8782H13.2802L9.54562 29.9038L6.32269 19.8782H0.152832L6.48089 38.5556H11.9439L15.5202 28.4552L19.0562 38.5556H24.5192L30.8473 19.8782H24.6774L21.4545 29.9404Z"
        fill="currentColor"
      />
      <path
        d="M15.5969 12.0729C15.8964 12.0735 16.1849 11.9668 16.4037 11.7744C16.6226 11.5821 16.7553 11.3185 16.775 11.0373L17.3674 2.57072C17.3821 2.48589 17.39 2.40015 17.391 2.31421C17.391 2.29996 17.391 2.28729 17.391 2.27304V2.24137C17.3711 1.81007 17.1749 1.40267 16.8435 1.10412C16.5121 0.805568 16.0709 0.638916 15.6121 0.638916C15.1532 0.638916 14.7121 0.805568 14.3807 1.10412C14.0492 1.40267 13.8531 1.81007 13.8332 2.24137H13.8113L14.4188 11.0373C14.4385 11.3185 14.5713 11.5821 14.7901 11.7744C15.009 11.9668 15.2974 12.0735 15.5969 12.0729Z"
        fill="currentColor"
      />
      <path
        d="M21.8148 13.3864L28.5973 7.7937C28.672 7.74656 28.7424 7.6936 28.8076 7.63536L28.8363 7.60527L28.8615 7.58469C29.1769 7.26759 29.3489 6.84758 29.3412 6.41336C29.3336 5.97915 29.1468 5.56474 28.8204 5.25767C28.4941 4.95059 28.0536 4.7749 27.5921 4.76769C27.1306 4.76048 26.6841 4.92232 26.3471 5.21904L26.332 5.20479L20.1537 11.822C19.9581 12.0336 19.8551 12.3072 19.8655 12.5875C19.8758 12.8678 19.9987 13.134 20.2094 13.3325C20.4201 13.5309 20.7029 13.6468 21.0008 13.6568C21.2987 13.6668 21.5896 13.5702 21.8148 13.3864Z"
        fill="currentColor"
      />
      <path
        d="M10.9086 13.3348C11.1198 13.1358 11.2427 12.8687 11.2524 12.5877C11.262 12.3066 11.1578 12.0326 10.9608 11.8211L4.78756 5.19282L4.77073 5.20707C4.4337 4.91036 3.98727 4.74852 3.52576 4.75572C3.06425 4.76293 2.62379 4.93863 2.29741 5.24571C1.97102 5.55278 1.78427 5.96719 1.77661 6.4014C1.76895 6.83561 1.94097 7.25563 2.25634 7.57273L2.28159 7.59331C2.29168 7.60281 2.3001 7.61389 2.31188 7.62339C2.37692 7.68124 2.4467 7.73419 2.52057 7.78174L9.30303 13.3744C9.52634 13.5601 9.81616 13.6593 10.1141 13.652C10.412 13.6446 10.6959 13.5313 10.9086 13.3348Z"
        fill="currentColor"
      />
    </svg>
  );
};

/*
 * Sprite-backed (see `@/assets/icons/sprite/IconSprite`): the wordmark is 5 KB of path data and
 * every page draws it at least twice (header and footer).
 */
export const WhoppahFullSize = (props: IconProps) => {
  return (
    <SpriteIcon
      symbol={SPRITE_SYMBOLS.whoppahFullSize}
      width="152"
      height="40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    />
  );
};
